import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from "react-ga4";
import { store } from './store/store'
import { Provider } from 'react-redux'
import reportWebVitals from './reportWebVitals';

import './index.css';
import App from './App';

const TRACKING_ID = "G-MDC2T7K0NS"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID, {
  gaOptions: {
    siteSpeedSampleRate: 100
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
